import { useMutation } from 'react-query'
import { type ExpertFromAdminPersistence } from '../../../../types/persistence/expert-persistence'
import { api } from '../../../api'

const updateExpert = async (id: number, data: ExpertFromAdminPersistence) => {
  const response = await api.put(`/experts/from-admin/${id}`, data)
  return response.data
}

export const useExpertEditMutation = () => {
  return useMutation('update-expert', {
    mutationFn: ({ id, data }: { id: number, data: ExpertFromAdminPersistence }) => {
      return updateExpert(id, data)
    },
  })
}
